import { showError } from '#imports';
import { readHttpErrorStatus } from './httpStatus';

const PUBLIC_STATUS = new Set([400, 403, 404, 409, 422, 429]);

export function isUnauthorizedError(error: unknown): boolean {
  return readHttpErrorStatus(error) === 401;
}

export function presentPageLoadError(error: unknown): void {
  if (isUnauthorizedError(error)) {
    return;
  }
  const statusCode = readHttpErrorStatus(error) ?? 500;
  const allowPublicMessage = PUBLIC_STATUS.has(statusCode);
  const message =
    allowPublicMessage && error instanceof Error && error.message.trim()
      ? error.message
      : 'pages.errors.unexpected';
  showError({
    statusCode,
    statusMessage: message,
    message,
    fatal: true,
  });
}

/** История показа принадлежит странице; актуальность запроса проверяется до report. */
export function createTableErrorReporter({
  canPresent,
  present,
  getContext = () => undefined,
}: {
  canPresent: () => boolean;
  present: (error: unknown) => void;
  getContext?: () => unknown;
}) {
  const presented = new Set<unknown>();
  let context: unknown;
  const reset = () => {
    presented.clear();
  };
  return {
    reset,
    report(error: unknown) {
      if (!canPresent() || isUnauthorizedError(error)) return;
      const nextContext = getContext();
      if (context !== nextContext) {
        reset();
        context = nextContext;
      }
      if (presented.has(error)) return;
      presented.add(error);
      present(error);
    },
  };
}
